module.exports = __webpack_public_path__ + "static/media/cssalogo-red-sm.0bb4b5e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cssalogo-red-sm.png
// module id = 710
// module chunks = 0